import {
  MarkerClusterer,
  SuperClusterAlgorithm,
} from "@googlemaps/markerclusterer";
import { memo, useEffect, useRef, useState } from "react";

const CustomerMarkers = ({ customers, mapRef }) => {
  const markersRef = useRef({});
  const [clusterer, setClusterer] = useState(null);

  /** ---------------- CREATE CLUSTERER ONCE ---------------- */
  useEffect(() => {
    if (!mapRef.current || !window.google) return;

    const newClusterer = new MarkerClusterer({
      map: mapRef.current,
      algorithm: new SuperClusterAlgorithm({ radius: 80 }),
    });

    setClusterer(newClusterer);

    return () => newClusterer?.clearMarkers();
    // eslint-disable-next-line
  }, [mapRef]);

  /** ---------------- REMOVE MARKERS THAT NO LONGER EXIST ---------------- */
  useEffect(() => {
    if (!clusterer) return;

    Object.keys(markersRef.current).forEach((id) => {
      const stillExists = customers.some((c) => c._id === id);

      if (!stillExists) {
        const { marker } = markersRef.current[id];
        clusterer.removeMarker(marker);
        marker.map = null;
        delete markersRef.current[id];
      }
    });
    // eslint-disable-next-line
  }, [customers, clusterer]);

  /** ---------------- RENDER CUSTOMER MARKERS ---------------- */
  useEffect(() => {
    if (!clusterer || !window.google?.maps?.marker?.AdvancedMarkerElement)
      return;

    customers.forEach((customer) => {
      const lat = Number(customer.location?.lat);
      const lng = Number(customer.location?.long);

      if (isNaN(lat) || isNaN(lng)) return;

      const exists = markersRef.current[customer._id];

      if (!exists) {
        const img = document.createElement("img");
        img.style.width = "45px";
        img.src = `${process.env.REACT_APP_PUBLIC_URL}/assets/markers/customer_marker.png`;

        const marker = new window.google.maps.marker.AdvancedMarkerElement({
          position: { lat, lng },
          content: img,
          map: mapRef.current,
          title: customer?.name || "Customer",
        });

        markersRef.current[customer._id] = { marker, img };
        clusterer.addMarker(marker);
      }
    });
    // eslint-disable-next-line
  }, [customers, clusterer]);

  return null;
};

export default memo(CustomerMarkers);
